import React, { useEffect, useState } from 'react';
import {
  Typography,
  ButtonGroup,
  Button
} from '@mui/material';
import { useLanguage } from '../../features/languageReducer';


const PostTranslate = ({ onClick, active, addDefault }) => {
  const [loading, setLoading] = useState(null);

  const languageList = useLanguage();

  const handleClick = (item) => {
    setLoading(item);
    onClick?.(item);
  };

  useEffect(() => {
    if (!active || (active === loading.code || active === loading.label)) {
      setLoading(null);
    }
  }, [active]);

  return (<>
    <Typography>Translate to:</Typography>
    <ButtonGroup size="small" aria-label="Small button group" style={{display:'inline-block'}}>
      {addDefault &&
        <Button
          disabled={!!loading}
          type="button"
          onClick={() => handleClick(null)}
          variant={active === '' && 'contained'}
        >
          E
        </Button>
      }
      {languageList.map(item => (
        <Button
          disabled={!!loading}
          loading={loading && (loading.code === item.code || loading.label === item.label)}
          type="button"
          onClick={() => handleClick(item)}
          variant={(active === item.code || active === item.label) && 'contained'}
        >
          {item.short_name[0]}
        </Button>
      ))}
    </ButtonGroup>
  </>);
};

export default PostTranslate;